import { Grid, Card, MenuItem, FormControl, Box, CircularProgress, Backdrop } from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout/index.js";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar/index.js";
import DataTable from "layouts/Tables/DataTable";
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
import { useMaterialUIController, setTicketContext } from "context";
import Link from '@mui/material/Link';
import VisibilityIcon from '@mui/icons-material/Visibility';
import configurations from "config";
import { VENDOR_TICKET } from 'constants';
import CreateTicket from './CreateTicket';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


function ManageTickets() {
  const navigate = useNavigate();
  const { pageNo } = useParams();
  var pageSelected = 1;
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { ticketContext, MyContext } = controller;

  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }

  const { t } = useTranslation();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [ticketData, setData] = useState({});
  const [newTicket, setNewTicket] = useState(0);
  const [responseResultCount, setResponseResultCount] = useState(0);
  const searchFilterData = { 'status': ticketContext.status, };
  const [isLoading, setIsLoading] = useState(true);
  const [isTicketContextChanged, setTicketContextChanged] = useState(false);

  const data = () => {
    setIsLoading(true);
    toast.dismiss();
    let queryParams = new URLSearchParams(searchFilterData).toString();
    queryParams = queryParams + "&pageSelected=" + pageSelected;
    axios({
      url: baseUrl + "/ticket/list?" + queryParams,
      method: "GET",
      headers: {
        Authorization: bearerToken,
        function: azureFunctionVendorFrontendKey
      }
    }).then(function (response) {
      setIsLoading(false);
      const message = response.data.message;
      response.status == 200 ?
        (
          response.data.status == 1 ?
            (setData(response.data),
              (response.data && response.data.data && response.data.data.totalCount) ?
                setResponseResultCount(response.data.data.totalCount)
                :
                null)
            :
            toast.error(t(message))
        )
        :
        toast.error(t('unableToProccessRequest'));
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  useEffect(() => {
    data();
  }, [pageNo, newTicket]);

  const handleResetFilters = () => {
    setTicketContext(dispatch, initialState.ticketContext);
    setTicketContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/tickets/list/page-1");
    else
      navigate("/tickets/list");
  };

  useEffect(() => {
    const hasChanged = Object.keys(ticketContext).some(
      key => ticketContext[key] !== initialState.ticketContext[key]
    );
    setTicketContextChanged(hasChanged);
  }, [ticketContext]);

  const columns = [
    { Header: t('Id'), accessor: "id", align: "left" },
    { Header: t('subject'), accessor: "subject", align: "left" },
    { Header: t("status"), accessor: "status", align: "left" },
    { Header: t("dataTime"), accessor: "date", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];

  const finalObj = [];
  if (ticketData.data && ticketData.data.rows) {
    let ticketRecords = ticketData.data.rows;
    for (const rowKey in ticketRecords) {
      let ticketRecord = ticketRecords[rowKey];
      if (ticketRecord.id > 0) {
        let tempObj = {
          id: '#' + ticketRecord.id,
          subject:
            <MDTypography component="a"
              href={"#"}
              onClick={(event) => { event.preventDefault(); navigate("/tickets/view/" + ticketRecord.id) }}
              variant="caption" color="text" fontWeight="medium">
              {ticketRecord.subject.substring(0, 50)}
            </MDTypography>,
          status: <span className={'statusD' + ticketRecord.status}>
            {
              (ticketRecord.status == VENDOR_TICKET.AWAITING_ADMIN_REPLY) ? <span>{t('awaitingAdminReply')}</span> :
                (ticketRecord.status == VENDOR_TICKET.CLOSED) ? <span>{t('closed')}</span> :
                  (ticketRecord.status == VENDOR_TICKET.AWAITING_VENDOR_REPLY) ? <span>{t('awaitingVendorReply')}</span> : null}</span>,
          date:
            <>
              <CalendarMonthIcon />{new Date(ticketRecord.createdAt).toLocaleDateString()}
              <span>{' , '}</span>
              <AccessTimeIcon />{new Date(ticketRecord.createdAt).toLocaleTimeString()}
            </>,
          action:
            <span className="actionClass">
              <Link href={"#"} className="view-link-ticket paddingRight5"
                onClick={(event) => { event.preventDefault(); navigate("/tickets/view/" + ticketRecord.id) }}
              >
                <Box className="squareBoxView"><VisibilityIcon color="primary" fontSize="medium" titleAccess={t("view")} /></Box>
              </Link>
            </span>
        };
        finalObj.push(tempObj);
      }
    }
  }

  const rows = finalObj;

  /* Post tickets*/

  const changeTicketParent = () => {
    (newTicket == 1) ? setNewTicket(0) : setNewTicket(1);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("manageTickets")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading} ><CircularProgress color="inherit" /></Backdrop>
      <MDBox pt={6} pb={3} >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {(newTicket == 1) ?
              <CreateTicket newTicket={newTicket} changeTicket={changeTicketParent} />
              :
              null
            }
            <Card className="ContentSectionBox">
              <MDBox className="ManageProductTopSec" mx={2} mt={0} py={3} px={2} variant="gradient">
                <Grid container className="FilterSectionBox ManageProductContainer" spacing={2} >
                  <Grid item xs={12} sm={3} md={3} className="filterGrid" >
                    <MDInput
                      select
                      name="status"
                      label={t('status')}
                      value={searchFilterData.status}
                      InputProps={{
                        classes: { root: "filterStyle" },
                      }}
                      className="ManageProductTopSecip"
                      onChange={(obj) => {
                        setTicketContext(dispatch, { ...ticketContext, status: obj.target.value });
                      }} fullWidth
                    >
                      <MenuItem value={'all'}>{t('All')}</MenuItem>
                      <MenuItem value={1}>{t('awaitingAdminReply')}</MenuItem>
                      <MenuItem value={2}>{t('awaitingVendorReply')}</MenuItem>
                      <MenuItem value={3}>{t('closed')}</MenuItem>
                    </MDInput>
                  </Grid>

                  <Grid item xs={12} sm={5} md={5} className="filterGrid">
                    <FormControl className="filterSubmit">
                      <MDButton
                        onClick={() => {
                          navigate("/tickets/list");
                          if (typeof pageNo === "undefined")
                            data();
                        }} key="submit" type="submit" color="info" size="small" disableRipple fullWidth>{t('submit')}</MDButton>
                      {isTicketContextChanged && (
                        <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                      )}
                    </FormControl>
                  </Grid>

                  {(newTicket == 0) ?
                    <Grid item xs={12} sm={4} md={4} className="filterGrid">
                      <MDButton onClick={() => { setNewTicket(1) }} key="submit" type="submit" color="info" size="small" disableRipple>{t('newTicket')}</MDButton>
                    </Grid>
                    :
                    null}
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  showTotalEntries={true}
                  responseResultCount={responseResultCount}
                  paginationSize={MyContext.paginationSize}
                  paginationLink={"/tickets/list/page-"}
                  pageSelected={pageSelected}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ManageTickets;
